import { InternalToolsCioCliToolRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/internal-tools/cio-cli-tool')({
  component: InternalToolsCioCliToolRoute,
});
